import React from "react";
import "./PoliticaPrivacidad.css";

const effectiveDate = "3 de septiembre de 2026";

export default function PoliticaPrivacidad() {
  return (
    <main className="privacy-page">
      <section className="privacy-hero">
        <a className="privacy-brand" href="/login" aria-label="Ir al inicio de MozzoApp">
          mozzo<span>app</span>
        </a>
        <p className="privacy-kicker">LEGAL Y PRIVACIDAD</p>
        <h1>Politica de privacidad de MozzoApp</h1>
        <p className="privacy-lead">
          Esta politica explica como MozzoApp trata la informacion necesaria para
          operar menus digitales, pedidos, delivery, pagos e integraciones de
          comunicacion para restaurantes.
        </p>
        <p className="privacy-date">Vigente desde el {effectiveDate}.</p>
      </section>

      <article className="privacy-content">
        <section>
          <h2>1. Responsable y alcance</h2>
          <p>
            El responsable legal de la plataforma es{" "}
            <strong>PORTILLO DIEGO ALBERTO</strong>, quien opera bajo el nombre
            comercial MozzoApp. MozzoApp es una plataforma de gestion
            gastronomica. Esta politica aplica a los restaurantes que usan la
            plataforma, a sus equipos de trabajo y a las personas que
            interactuan con sus menus, pedidos, delivery, kioscos y canales
            digitales.
          </p>
        </section>

        <section>
          <h2>2. Informacion que podemos tratar</h2>
          <ul>
            <li>Datos operativos del restaurante, sus sucursales, menus y personal autorizado.</li>
            <li>Datos de pedidos: productos, cantidades, observaciones, estado, fecha y canal.</li>
            <li>Datos de delivery proporcionados por el cliente: nombre, telefono y direccion.</li>
            <li>Referencias de cobros y pagos. MozzoApp no almacena datos completos de tarjetas.</li>
            <li>Mensajes de WhatsApp y otros canales cuando se usan para atender pedidos.</li>
            <li>
              Datos de Riders: identidad, DNI, fecha de nacimiento, selfie, resultado de
              prueba de vida, medio de reparto y documentacion de conducir cuando
              corresponda.
            </li>
            <li>
              Ubicacion y eventos operativos del Rider durante la disponibilidad y las
              entregas, para asignar y seguir los pedidos.
            </li>
            <li>Datos tecnicos minimos para seguridad, prevencion de fraude y mejora del servicio.</li>
          </ul>
        </section>

        <section>
          <h2>3. Para que usamos la informacion</h2>
          <p>Usamos la informacion exclusivamente para:</p>
          <ul>
            <li>Crear, administrar y entregar pedidos solicitados por los clientes.</li>
            <li>Gestionar menus, stock, cocina, caja, delivery y atencion por WhatsApp.</li>
            <li>Enviar confirmaciones, actualizaciones necesarias y enlaces de pedido.</li>
            <li>Brindar soporte, resolver incidentes y proteger la seguridad de la plataforma.</li>
            <li>
              Revisar manualmente la identidad y habilitacion de Riders, prevenir
              suplantaciones y mantener trazabilidad de las entregas.
            </li>
            <li>Cumplir obligaciones legales, fiscales o regulatorias aplicables.</li>
          </ul>
        </section>

        <section>
          <h2>4. Servicios que intervienen</h2>
          <p>
            Para operar MozzoApp puede integrar servicios de infraestructura,
            pagos y comunicaciones, entre ellos Supabase, Cloudflare, Mercado
            Pago y la Plataforma de WhatsApp Business de Meta. Cada proveedor
            procesa datos bajo sus propios terminos y politicas de privacidad.
          </p>
          <p>
            Las funciones de asistencia automatizada solo se habilitan cuando el
            restaurante las activa y se limitan a la informacion necesaria para
            responder una consulta o asistir con el menu.
          </p>
        </section>

        <section>
          <h2>5. WhatsApp Business</h2>
          <p>
            Cuando un restaurante conecta WhatsApp Business, MozzoApp utiliza
            los mensajes recibidos para identificar la conversacion, ofrecer el
            menu o chatbot de delivery, registrar los datos indispensables del
            pedido y responder al cliente. No vendemos ni cedemos mensajes o
            numeros de telefono para fines publicitarios ajenos al servicio.
          </p>
        </section>

        <section>
          <h2>6. Conservacion y seguridad</h2>
          <p>
            Conservamos la informacion durante el tiempo necesario para operar
            el servicio, atender reclamos, cumplir obligaciones legales y
            mantener la trazabilidad de pedidos y cobros. Aplicamos medidas
            tecnicas y organizativas razonables para proteger los datos contra
            accesos no autorizados, perdida o alteracion.
          </p>
          <p>
            La selfie y el DNI del Rider se guardan en almacenamiento privado. El video
            usado para la prueba de vida no se conserva: se almacena la selfie final, el
            resultado de la prueba y el registro de los consentimientos. El acceso a los
            documentos se limita al Rider y al personal autorizado para su revision.
          </p>
        </section>

        <section>
          <h2>7. Derechos y eliminacion de datos</h2>
          <p>
            Las personas pueden solicitar acceso, correccion o eliminacion de
            sus datos contactando directamente al restaurante que tomo el
            pedido. El restaurante puede gestionar esos datos desde MozzoApp.
            Si la solicitud corresponde a la plataforma, puede enviarse a
            <a href="mailto:privacidad@mozzoapp.com"> privacidad@mozzoapp.com</a>
            con el asunto &quot;Privacidad MozzoApp&quot;.
          </p>
          <p>
            Para eliminar datos vinculados a una conversacion de WhatsApp,
            indica el numero utilizado, el restaurante y una descripcion de la
            solicitud. Procesaremos el pedido segun las obligaciones de
            conservacion que correspondan.
          </p>
        </section>

        <section>
          <h2>8. Actualizaciones</h2>
          <p>
            Podemos actualizar esta politica para reflejar cambios operativos,
            tecnicos o normativos. La version vigente se publica siempre en
            esta misma pagina con su fecha de actualizacion.
          </p>
        </section>
      </article>
    </main>
  );
}
